import { uiController } from '@/controllers/uiController'
import { userService } from '@/services/userService'
import emitter, { MobileEmitterEvents, PcEmitterEvents } from './emitter'
import { commonUtils } from './commonUtils'
import { envHelper } from './envHelper'

// 移动端登录装饰器
export function MobileLoginDecorator(runAfterLogin: boolean = true) {
  return function (_target: any, _propertyKey: string, descriptor: any) {
    const origin = descriptor.value
    descriptor.value = async function (...args: any[]) {
      await userService.getUserInfo()
      if (!userService.isLogin) {
        if (commonUtils.isMobile() && commonUtils.isWechat()) {
          window.location.href = envHelper.wxAuthorizeUrl
          return
        }

        uiController.loginDialogProps.visible = true
        if (runAfterLogin) {
          return new Promise((resolve) => {
            emitter.once(MobileEmitterEvents.MOBILE_LOGIN_SUCCESS, () => {
              resolve(origin.apply(this, args))
            })
          })
        }
      } else {
        return origin.call(this, ...args)
      }
    }
  }
}

// PC端登录装饰器
export function PcLoginDecorator(runAfterLogin: boolean = true) {
  return function (_target: any, _propertyKey: string, descriptor: any) {
    const origin = descriptor.value
    descriptor.value = async function (...args: any[]) {
      await userService.getUserInfo()
      if (!userService.isLogin) {
        if (commonUtils.isWechat()) {
          window.location.href = envHelper.wxAuthorizeUrl
          return
        }

        uiController.PcLoginModalProps.visible = true
        if (runAfterLogin) {
          return new Promise((resolve) => {
            emitter.once(PcEmitterEvents.PC_LOGIN_SUCCESS, () => {
              resolve(origin.apply(this, args))
            })
          })
        }
      } else {
        return origin.call(this, ...args)
      }
    }
  }
}
